import { atom } from "recoil";

export const WelcomeProcessingState = atom<boolean>({
  key: "WelcomeProcessingState",
  default: false,
});
